import React from "react";
import { SvgIconProps } from "./SvgIconProps";

const InfoIcon: React.FC<SvgIconProps> = ({ color, ...props }) => (
    <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" {...props}>
        <path fill={color || "currentColor"} d="M5.516 0a5.52 5.52 0 0 1 5.516 5.516 5.52 5.52 0 0 1-5.516 5.516A5.518 5.518 0 0 1 0 5.516 5.518 5.518 0 0 1 5.516 0zm.727 4.491V8.73h-1.53V4.491h1.53zm-.765-.784c-.312 0-.538-.059-.679-.176-.141-.117-.212-.3-.212-.553 0-.258.071-.446.212-.563.141-.117.367-.175.679-.175.306 0 .531.058.675.175.144.117.216.305.216.563 0 .252-.072.436-.216.553-.144.117-.369.176-.675.176z"/>
    </svg>
);

export default InfoIcon;